import styled, { css } from 'styled-components';
export const Headline = styled.button `
  left: var(--space-n200);
  right: var(--space-n200);
  width: calc(100% + var(--space-200) * 2);
  padding-top: var(--space-150);
  padding-bottom: var(--space-100);
  background: var(--bg-secondary);

  ${({ $hovered }) => $hovered &&
    css `
      background: var(--bg-tertiary);
    `}

  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-100);
  letter-spacing: var(--font-letter-spacing-loosest);
  text-transform: uppercase;
  color: var(--text-secondary);

  position: relative;
`;
export const HeadlineIcon = styled.div `
  position: absolute;
  right: var(--space-250);
  top: 50%;
  transform: translateY(-50%);
`;
export const Content = styled.div `
  margin-left: var(--space-n200);
  margin-right: var(--space-n200);
  width: calc(100% + var(--space-200) * 2);
  background: var(--bg-primary);
`;
export const Row = styled.div `
  border-bottom: 1px solid var(--border-secondary);

  display: flex;

  & + & {
    margin-top: -1px;
  }

  &:hover {
    background: var(--bg-secondary);
  }
`;
export const Cell = styled.div `
  padding: var(--space-500) var(--space-400);

  flex: ${({ $flex }) => $flex};

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  font-size: var(--font-size-300);
  letter-spacing: var(--font-letter-spacing-dense);
  color: var(--text-primary);
`;
export const Footer = styled.footer `
  margin-top: -1px;
  padding: var(--space-400) var(--space-400);
  border-top: 1px solid var(--border-secondary);
`;
